// passing the path into variables

const destination1 = '/assets/buseslafit/destinations/dest1.webp'
const destination2 = '/assets/buseslafit/destinations/dest2.webp'
const destination3 = '/assets/buseslafit/destinations/dest3.webp'
const destination4 = '/assets/buseslafit/destinations/dest4.webp'
const destination5 = '/assets/buseslafit/destinations/dest5.webp'
const destination6 = '/assets/buseslafit/destinations/dest6.webp'
const destination7 = '/assets/buseslafit/destinations/dest7.webp'
const destination8 = '/assets/buseslafit/destinations/dest8.webp'
const destination9 = '/assets/buseslafit/destinations/dest9.webp'
const destination10 = '/assets/buseslafit/destinations/dest10.webp'
const destination11 = '/assets/buseslafit/destinations/dest11.webp'


const destination = [destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination8, destination9, destination10, destination11];


const lafitSlides = {
	destination,
}

export default lafitSlides


// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/lafitSlides.js